export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const PageMap = {
  THANK_YOU_PAGE: 'thank_you_page',
  CHECKOUT: 'checkout'
};
export const RESULT_PROP_NAME = 'expressCheckoutButtonsResult';
export const EXTENDED_FIELDS_FORM_ID = '391eeac7-0183-4955-8663-99bb01ab0ab4';
export let FastFlowRedirectionReason = /*#__PURE__*/function (FastFlowRedirectionReason) {
  FastFlowRedirectionReason["hasTermsAndConditions"] = "hasTermsAndConditions";
  FastFlowRedirectionReason["shouldChooseShippingMethod"] = "shouldChooseShippingMethod";
  FastFlowRedirectionReason["hasCustomField"] = "hasCustomField";
  FastFlowRedirectionReason["hasViolations"] = "hasViolations";
  FastFlowRedirectionReason["hasTotalAmountMismatchWithLatestSeen"] = "hasTotalAmountMismatch";
  FastFlowRedirectionReason["hasTaxZipCodeError"] = "hasTaxZipCodeError";
  FastFlowRedirectionReason["hasTaxSubdivisionError"] = "hasTaxSubdivisionError";
  FastFlowRedirectionReason["hasShippingZipCodeError"] = "hasShippingZipCodeError";
  FastFlowRedirectionReason["hasShippingSubdivisionError"] = "hasShippingSubdivisionError";
  FastFlowRedirectionReason["unknown"] = "unknown";
  return FastFlowRedirectionReason;
}({});
//# sourceMappingURL=consts.js.map